var RowSizes = {
  compact: 28,
  normal: 36,
  extend: 56
};
var RowSizesOptions = {
  compact: 'compact',
  normal: 'normal',
  extend: 'extend'
};
var RowSizesOptionsArr = [RowSizesOptions.compact, RowSizesOptions.normal, RowSizesOptions.extend];

export { RowSizes, RowSizesOptions, RowSizesOptionsArr };
//# sourceMappingURL=rowSizes.js.map
